import {Component} from '@angular/core';

@Component({
  selector: 'voice-menu-ico',
  templateUrl: './voice-menu-ico.component.html'
})
export class VoiceMenuIcoComponent {
}
